// extracted by mini-css-extract-plugin
module.exports = {"container":"b1ddd01198--container--k70Yq","edit-button":"b1ddd01198--edit-button--lCL08"};